export enum EProviderSpecialty {
  Carpentry = 'carpentry',
  Cleaning = 'cleaning',
  Electricity = 'electricity',
  Flooring = 'flooring',
  GardeningOutside = 'gardening_outside',
  GeneralRenovation = 'general_renovation',
  GlassWindowsDoors = 'glass_windows_doors',
  Heating = 'heating',
  Insulation = 'insulation',
  Leak = 'leak',
  Masonry = 'masonry',
  PaintingPlastering = 'painting_plastering',
  Plumbing = 'plumbing',
  Roofing = 'roofing',
  Security = 'security',
  SolarPanel = 'solar_panel',
  VentilationAc = 'ventilation_ac',
  Veranda = 'veranda',
}

export enum EProviderRole {
  Expert = 'expert',
  External = 'external',
}
